import BaseObjectStore from './base-object.store';
import { makeObservable, observable, action } from 'mobx';
import axiosBarwiseInstance from 'libs/axios/axios.lib';
import { toast } from 'react-toastify';

class ThemeStore extends BaseObjectStore {
  defaultThemeConfig = {
    color_primary: '#ffffff',
    color_secondary: '#FF0000',
    color_background: '#000000',
    color_surface: '#121212',
    logo_dark: './logo-dark.png',
    logo_light: './logo-light.png',
    logo_icon: './logo-icon.png'
  };
  themeConfig = {};

  constructor(props) {
    super(props);
    this.name = 'theme';
    this.themeConfig = this.defaultThemeConfig;
    makeObservable(this, {
      defaultThemeConfig: observable,
      setDefaultThemeConfig: action,
      themeConfig: observable,
      setThemeConfig: action,
      getSetCurrentTheme: action,
      resetAllFields: action
    });
  }

  getThemeConfig() {
    return this.themeConfig;
  }

  getDefaultThemeConfig() {
    return this.defaultThemeConfig;
  }

  // Get current dark logo URL
  getDarkLogoUrl() {
    return this.themeConfig.logo_dark;
  }

  // Get current light logo URL
  getLightLogoUrl() {
    return this.themeConfig.logo_light;
  }

  // Update entire theme configuration
  setThemeConfig(themeConfig) {
    this.themeConfig = { ...themeConfig };
    return this.themeConfig;
  }

  setDefaultThemeConfig(defaultThemeConfig) {
    this.defaultThemeConfig = { ...defaultThemeConfig };
    return this.defaultThemeConfig;
  }

  validateThemeConfig(themeConfig) {
    return (
      themeConfig.color_primary &&
      themeConfig.color_secondary &&
      themeConfig.color_background &&
      themeConfig.color_surface
    );
  }

  async getSetCurrentTheme() {
    this.setIsLoading(true);
    try {
      const response = await axiosBarwiseInstance.get('/api/current-theme');
      if (response.status === 200) {
        const config = response.data;
        if (config) {
        const themeConfig = {
            color_primary: config.color_primary,
            color_secondary: config.color_secondary,
            color_background: config.color_background,
            color_surface: config.color_surface,
            logo_dark: config.logo_dark,
            logo_light: config.logo_light,
            logo_icon: config.logo_icon
          };
          this.setThemeConfig(themeConfig);
        }
      }
    } catch (error) {
      console.error('Error getting current theme');
    } finally {
      this.setIsLoading(false);
    }
  }

  resetToDefault() {
    this.setThemeConfig(this.defaultThemeConfig);
    return this.themeConfig;
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new ThemeStore();
